import Path from "@core/FileProvider/Path/Path";
import assert from "assert";
import type { ToolExecutionContext } from "../tool";

export type ResourceTools = Pick<ToolExecutionContext, "app" | "ctx" | "commands">;

export async function saveArticleResource(
	{ ctx, commands }: ResourceTools,
	data: Uint8Array,
	fileName: string,
	catalogName: string,
	articlePath: Path,
	keepFormat: boolean,
): Promise<string> {
	const setCmd = commands.article.resource.set;
	const args = setCmd.params(
		ctx,
		{
			src: `./${fileName}`,
			articlePath: articlePath.value,
			catalogName,
			force: "false",
			keepFormat: String(keepFormat),
		},
		{ data: Buffer.from(data) },
	);
	const res = (await setCmd.do(args)) as { path?: string } | undefined;
	return `./${new Path(res?.path ?? fileName).nameWithExtension}`;
}

export async function saveAttachmentAsResource(
	tools: ResourceTools,
	sessionId: string,
	attachmentName: string,
	catalogName: string,
	articlePath: Path,
): Promise<string> {
	const bytes = await tools.app.agentManager.attachments.getBytes(sessionId, attachmentName);
	assert(bytes, `Attachment not found: ${attachmentName}`);
	return saveArticleResource(tools, bytes, attachmentName, catalogName, articlePath, false);
}
